import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { SignUserModel } from '../model/sign-user-model';
import { SuiteUserAuth } from '../model/suite-user-auth';

@Injectable({
  providedIn: 'root',
})
export class AuthUtilService {
  public user: Observable<SuiteUserAuth>;
  public userSign: Observable<SignUserModel>;
  private userSubject: BehaviorSubject<SuiteUserAuth>;
  private userSubjectSign: BehaviorSubject<SignUserModel>;
  private _jwtCookieName: string = 'satelittiJwtToken';
  private _userStorageName: string = 'satelittiUser';
  private _userSignStorageName: string = 'signUser';

  constructor(private cookieService: CookieService) {
    this.userSubject = new BehaviorSubject<SuiteUserAuth>(null);
    this.userSubjectSign = new BehaviorSubject<SignUserModel>(null);
    this.user = this.userSubject.asObservable();
    this.userSign = this.userSubjectSign.asObservable();
  }

  getJwtToken(): string {
    return this.cookieService.get(this._jwtCookieName);
  }

  clearJwtToken() {
    this.cookieService.delete(this._jwtCookieName, '/');
  }

  setUser(user: SuiteUserAuth) {
    if (!user) {
      localStorage.removeItem(this._userStorageName);
    } else {
      localStorage.setItem(this._userStorageName, btoa(JSON.stringify(user)));
      this.userSubject.next(user);
    }
  }

  setUserSign(signUser: SignUserModel) {
    if (!signUser) {
      localStorage.removeItem(this._userSignStorageName);
    } else {
      localStorage.setItem(
        this._userSignStorageName,
        btoa(JSON.stringify(signUser))
      );
      this.userSubjectSign.next(signUser);
    }
  }

  getUserIdFromJwtToken(): string {
    var jwtToken = JSON.parse(atob(this.getJwtToken().split('.')[1]));

    return jwtToken[
      'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/sid'
    ];
  }

  public get userValue(): SuiteUserAuth {
    if (!this.userSubject.value) {
      var user = localStorage.getItem(this._userStorageName);

      if (user) this.userSubject.next(JSON.parse(atob(user)));
    }

    return this.userSubject.value;
  }

  getUserSingLocalStorage() {
    var user = localStorage.getItem(this._userSignStorageName);
    if (!user) return '';
    return user;
  }
}
